import React from "react";

const OptionListNodeContent = ({
  nodeData,
  editNode
}) => {
  return (
    <div className="chatbot-node-container">
      <div className="node-header">
        <div className="d-flex justify-content-between w-100">
          <span className="text-gray-dark fz-8 mt-5">{nodeData.option?.text}</span>
          <div className="icon-action" onClick={editNode}>
            <div className="tooltip-top">
              <i className="mi-edit-outline text-secondary fz-10" />
              <span className="tooltiptext--black bg-dark tooltiptext tooltip-stats-view">
                Editar
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OptionListNodeContent;
